import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialog, { DialogProps as MuiDialogProps } from "@mui/material/Dialog";

export const Dialog = (props: MuiDialogProps) => {
  return <MuiDialog {...props} />;
};

export const DialogContent = (
  props: React.ComponentProps<typeof MuiDialogContent>,
) => {
  return <MuiDialogContent style={{ ...props.style, padding: 0 }} {...props} />;
};

export { MuiDialogTitle as DialogTitle };
